module.exports = __webpack_public_path__ + "img/receipt.3041f660.png";